import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Row,
} from "reactstrap"
import { FormProvider, useFieldArray, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { UFDate, UFInput } from "../../../components/Common/Fields/Input"
import PaymentMode from "../../../components/Common/chooseFields/paymentMode"
import LoadingButton from "../../../components/Common/LoadingButton"
import Location from "../../../components/Common/chooseFields/location"
import lightTrash from "../../../assets/icons/light-trash.svg"
import Priority from "../../../components/Common/chooseFields/priority"
import {
  fetchMRRequest,
  fetchMRRequesting,
  fetchRequest,
  postMaterialRequest,
  postMaterialRequestFinance,
  postMaterialRequesting,
} from "../../../services/procurement/materialrequest"
import moment from "moment"
import Productcode from "../../../components/Common/chooseFields/Product"
import { fetchProjecrtMaster } from "../../../services/projectManager/projectMaster"
import MaterialProjectNo from "../../../components/Common/chooseFields/materailProject"
import PhoneInputField from "../../../components/Common/Fields/phoneInput"
import MaterialProductList from "../../../components/Common/chooseFields/materialProductList"
import { useSelector } from "react-redux"

const schema = yup.object().shape({
  project_id: yup.mixed().required("project code is required"),
  date: yup
    .mixed()
    .test(
      "is-future-date",
      "Make sure the request date is forward-looking",
      function (value) {
        if (!value) return true
        const currentDate = moment()
        const selectedDate = moment(value)
        return selectedDate.isSameOrAfter(currentDate, "day")
      }
    )
    .required("Delivery Date is required"),

  material_req: yup.array().of(
    yup.object().shape({
      product_id: yup.mixed().required("product code is required"),

      quantity: yup
        .string()
        .matches(
          /^(?!0+(\.0+)?$)\d*(\.\d+)?$/,
          "Quantity must be a non-negative number and cannot be zero"
        ).required("Quantity is required"),
    })
  ),
})

const EditMaterialRequesting = ({ fromDashboard, projectValue, toggle }) => {
  const navigate = useNavigate()
  const { id } = useParams()
  const now = moment()
  const [isLoading, setIsLoading] = useState(false)
  const [projectID, setProjectID] = useState()

  const loggedUser = useSelector(state => state.Login.loggedUser)

  const {
    control,
    handleSubmit,
    watch,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      project_id: null,
      contact_number: "",
      requested_by: "",
      date: moment(now, "YYYY-MM-DD").toDate(),
      delivery_location: null,
      material_req: [
        {
          id: "",
          product_id: null,
          quantity: "",
          description: "",
          // priority: null,
          initial_quantity: "",
          received_quantity: "",
        },
      ],
    },
  })
  // const methods = useForm({
  //   resolver: yupResolver(schema),
  //   mode: "onChange",
  //   shouldFocusError: true,
  // })
  const {
    fields: materialFields,
    append: materialAppend,
    remove: materialRemove,
  } = useFieldArray({
    control,
    name: "material_req",
  })

  const handleRegistration = async data => {
    const Requestarray = data?.material_req?.map(dt => ({
      id: dt?.id,
      material_id: dt?.product_id?.value,
      // priority: dt?.priority?.value,
      //   description: dt?.description,
      quantity: dt?.quantity,
      //   unit_id: dt?.unit_id,
    }))
    try {
      setIsLoading(true)
      const update = await postMaterialRequesting({
        ...data,
        // save_as_draft: action == 1 ? 0 : 1,
        // requested_by: loggedUser?.data?.id,
        // contact_number: 0,
        // delivery_location: data?.delivery_location,
        project_id: data?.project_id?.value,
        items: Requestarray,
        // exp_Delivery_date: moment(data?.exp_Delivery_date).format("YYYY-MM-DD"),
        date: moment(data?.date).format("YYYY-MM-DD"),
      })
      if (fromDashboard) {
        toggle()
      } else {
        navigate("/procurement-material-req")
      }
      toastSuccess(update?.message)
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
    }
  }

  const handleProjectChange = () => {
    const { project_id } = getValues()
    fetchProjectData(project_id?.value)
    setProjectID(project_id?.value)
  }

  useEffect(() => {
    if (fromDashboard) {
      setValue("project_id", projectValue)
      fetchProjectData(id)
      setProjectID(id)
    }
    const fetchMrEdit = async id => {
      const responce = await fetchMRRequesting(id)
      console.log(`responce edit`, responce)
      const materialsArr = responce?.data?.items?.map(dt => ({
        product_id: {
          label: dt?.material?.product_code,
          value: dt?.material?.id,
          ...dt?.material
        },
        quantity: dt?.quantity,
      }))
      reset({
        ...responce?.data,
        project_id: {
          label: responce?.data?.project?.project_code,
          value: responce?.data?.project?.id,
        },
        project_name: responce?.data?.project?.project_name,
        exp_Delivery_date: responce?.data?.exp_Delivery_date,
        material_req: materialsArr,
      })
    }
    if (id) {
      fetchMrEdit(id)
    }
  }, [fromDashboard, id])

  const fetchProjectData = async idData => {
    const response = await fetchProjecrtMaster(idData)
    if (idData == response.data?.id) {
      const Requestarray = response.data?.project_material
        ?.map(dt => {
          const projectMrQuantitySum = dt.project_mr.reduce(
            (total, mr) => total + parseFloat(mr.quantity),
            0
          )

          const alreadyReceived = dt.project_mr.length
            ? dt.quantity - projectMrQuantitySum
            : 0
          const balanceQty = dt.project_mr.length ? projectMrQuantitySum : 0
          const quantity = dt.project_mr.length ? dt.quantity : dt.quantity
          return {
            product_id: {
              value: dt?.product_code?.id,
              label: dt?.product_code?.product_code,
              storeCount: dt?.products?.storeCount,
            },
            description: dt?.description,
            quantity: quantity,
            initial_quantity: dt?.quantity,
            received_quantity: balanceQty,
            unit_id: dt?.unit?.id,
          }
        })
        .filter(item => item.quantity !== 0)
      const previousDatas = getValues()
      reset({
        ...previousDatas,
        project_name: response.data?.project_name,
        material_req: Requestarray,
        delivery_location: response.data?.location?.name,
      })
    }
  }
  return (
    <React.Fragment>
      <div
        className={`${
          fromDashboard ? "pt-0 dashboard-page-content" : "page-content"
        }`}
      >
        <div className="container-fluid">
          <FormProvider>
            <Form
              id={`request-form`}
              onSubmit={handleSubmit(handleRegistration)}
            >
              <div className="sticky-top w-100">
                <div className="d-flex justify-content-between pe-3">
                  {!fromDashboard ? (
                    <Breadcrumbs
                      title="Procurement"
                      breadcrumbObject={[
                        { title: "Procurement", link: "/procurement" },
                        {
                          title: "Material Request",
                          link: "/procurement-material-req",
                        },
                        {
                          title: id
                            ? "Edit Material Request"
                            : "Add Material Request",
                          link: "",
                        },
                      ]}
                    />
                  ) : (
                    <div></div>
                  )}
                  <div>
                    <LoadingButton
                      form={`request-form`}
                      color={"primary"}
                      loading={isLoading}
                      disabled={isLoading}
                      className={"px-2 mb-3 ms-2 btn btn-primary"}
                      type="submit"
                    >
                      {fromDashboard ? "Save" : id ? "Update" : "Save"}
                    </LoadingButton>
                  </div>
                </div>
              </div>
              <Container fluid className="ps-lg-0">
                <Card className="invoice-main-card p-3 pt-4">
                  <Row className="mb-1 mt-2">
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Project Code<span className="mandatory">*</span>
                        </Label>
                        <MaterialProjectNo
                          control={control}
                          placeholder="Enter the project code"
                          name={"project_id"}
                          target={fromDashboard ? ".modal" : "body"}
                          onSelectChange={handleProjectChange}
                          invalid={!!errors.project_id}
                          disabled={fromDashboard}
                          is_budgeted={1}
                        />
                        <FormFeedback invalid>
                          {errors.project_id?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>Project name</Label>
                        <UFInput
                          control={control}
                          placeholder="Enter the project name"
                          name={"project_name"}
                          invalid={!!errors.project_name}
                        />
                        <FormFeedback invalid>
                          {errors.project_name?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Request date <span className="mandatory">*</span>
                        </Label>
                        <UFDate
                          control={control}
                          name={"date"}
                          invalid={!!errors.date}
                        />
                        <FormFeedback invalid>
                          {errors.date?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    {/* <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Exp. Delivery date{" "}
                          <span className="mandatory">*</span>
                        </Label>
                        <UFDate
                          control={control}
                          name={"exp_Delivery_date"}
                          invalid={!!errors.exp_Delivery_date}
                        />
                        <FormFeedback invalid>
                          {errors.exp_Delivery_date?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col> */}
                  </Row>
                  <hr className="m-0" />
                  <Row className="py-2 mt-1">
                    <h5>Material Details</h5>
                  </Row>
                  <Row className="mb-4">
                    <Col lg={12}>
                      <table className="estimation-table mb-4">
                        <thead>
                          <tr>
                            <th>Product Code</th>
                            <th>Quantity</th>
                            <th>Store Availability</th>
                            {/* <th>Description</th> */}
                            {/* <th>Priority</th> */}
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {materialFields.map((item, index) => (
                            <tr key={`materialFields${item.id || index}`}>
                              <td className="ps-1">
                                <MaterialProductList
                                  control={control}
                                  placeholder="Product Code"
                                  projectid={projectID}
                                  selectedProduct={watch(`material_req`)}
                                  index={index}
                                  name={`material_req.${index}.product_id`}
                                  invalid={
                                    !!errors?.material_req?.[index]?.product_id
                                  }
                                />
                                <FormFeedback invalid>
                                  {
                                    errors?.material_req?.[index]?.product_id
                                      ?.message
                                  }
                                </FormFeedback>
                              </td>
                              <td className="ps-1">
                                <UFInput
                                  control={control}
                                  placeholder="Quantity"
                                  name={`material_req.${index}.quantity`}
                                  invalid={
                                    !!errors?.material_req?.[index]?.quantity
                                  }
                                />
                                <FormFeedback invalid>
                                  {
                                    errors?.material_req?.[index]?.quantity
                                      ?.message
                                  }
                                </FormFeedback>
                              </td>
                              <td className="ps-1">
                                <div className="fs-13">
                                  {watch(`material_req.${index}.product_id`)
                                    ?.storeCount
                                    ? watch(`material_req.${index}.product_id`)
                                        ?.storeCount
                                    : 0}
                                </div>
                              </td>
                              {/* <td className="ps-1">
                                <UFInput
                                  control={control}
                                  placeholder="Description"
                                  name={`material_req.${index}.description`}
                                  invalid={
                                    !!errors?.material_req?.[index]?.description
                                  }
                                />
                                <FormFeedback invalid>
                                  {
                                    errors?.material_req?.[index]?.description
                                      ?.message
                                  }
                                </FormFeedback>
                              </td> */}
                              {/* <td className="ps-1">
                                <Priority
                                  control={control}
                                  placeholder="Priority"
                                  name={`material_req.${index}.priority`}
                                  invalid={
                                    !!errors?.material_req?.[index]?.priority
                                  }
                                />
                                <FormFeedback invalid>
                                  {
                                    errors?.material_req?.[index]?.priority
                                      ?.message
                                  }
                                </FormFeedback>
                              </td> */}
                              <td>
                                <div className="pb-1 px-2 d-flex justify-content-center">
                                  <img
                                    src={lightTrash}
                                    alt="light-trash"
                                    className="trash-img pointer"
                                    onClick={() => materialRemove(index)}
                                  />
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {!fromDashboard && (
                        <Col
                          lg="12"
                          xs={12}
                          md={2}
                          sm={12}
                          className="d-flex justify-content-between"
                        >
                          <Button
                            color="secondary"
                            className="addButton mt-2"
                            onClick={() =>
                              materialAppend({
                                product_id: "",
                                description: "",
                                quantity: "",
                                // priority: "",
                              })
                            }
                          >
                            Add Row
                          </Button>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </Card>
              </Container>
            </Form>
          </FormProvider>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditMaterialRequesting
